import { Injectable } from '@angular/core';
import { config } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Orden } from '../models/orden';
import { OrdenDetalle } from '../models/ordendetalle';

@Injectable({
  providedIn: 'root',
})
export class OrdenService {
  API = `${config.apiURL}/api/orden`;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded;application/json',
    }),
    timeout: 0,
    method: 'POST',
  };

  constructor(public http: HttpClient) {}

  getOrden(id: number) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Orden[]>(`${this.API}/${id}`)
        .subscribe(data => {
          // Success
          resolve(data);
        },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  getOrdenesCliente(id: any) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Orden[]>(`${this.API}/cliente/${id}`).subscribe((data) => {
        // Success
        resolve(data);
      },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  addOrden(id: number, sucursal: number, value: any) {
    const promise = new Promise((resolve, reject) => {
      this.http.post(this.API, { Cliente: id, Sucursal: sucursal, Productos: value }, this.httpOptions).subscribe((data) => {
        // Success
        resolve(data);
        }, (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  updateOrden(id: number, nombre: string, correo: string, telefono: string) {
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.API}/update/${id}`,
          {
            cOrdenNombre: nombre,
            cOrdenCorreo: correo,
            cOrdenTelefono: telefono,
          },
          this.httpOptions
        )
        .subscribe(
          (data) => {
            // Success
            resolve(data);
          },
          (error) => {
            console.log('Error Service', error);
            reject(error);
          }
        );
    });
    return promise;
  }

  updatePedido(id: number, tipo: any, hora: any, estatus: number) {
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.API}/update/${id}`,
          { cOrdenTipo: tipo, cOrdenHoraRecoge: hora, cOrdenEstatus: estatus },
          this.httpOptions
        )
        .subscribe(
          (data) => {
            // Success
            resolve(data);
          },
          (error) => {
            console.log('Error Service', error);
            reject(error);
          }
        );
    });
    return promise;
  }

  addDomicilio(id: number, lat: number, lng: number) {
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.API}/update/${id}`,
          { cOrdenLatitud: lat, cOrdenLongitud: lng },
          this.httpOptions
        )
        .subscribe(
          (data) => {
            // Success
            resolve(data);
          },
          (error) => {
            console.log('Error Service', error);
            reject(error);
          }
        );
    });
    return promise;
  }

  getOrdenDetalle(id: number) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<OrdenDetalle[]>(`${this.API}/detalle/${id}`)
        .subscribe(data => {
          // Success
          resolve(data);
        },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }
}
